<!--
 * @Author: Lemon C
 * @Date: 2024-03-27 11:33:13
 * @LastEditTime: 2025-03-11 18:40:56
-->
<template>
    <div class="nav-control-body">
        <NavHeader
            :style="nav_header_bg_color"
            :menuItems="$globalObj.nav_item_list"
            :navRouterCallBack="nav_header_router"
            :navTranPlatformCallBack="nav_tran_platform"
            :navUserCallBack="nav_user">
        </NavHeader>
        <DynamicBg class="dynamic-bg-color">
            <div class="custom-sup-box" ref="ref_custom_sup_box">
                <router-view class="route-content-body" />
                <NavFooter v-if="state_store.need_footer" :nav_footer_router_callback="nav_footer_router"></NavFooter>
            </div>
        </DynamicBg>
        <ScrollTopBtn v-if="state_store.need_scroll_top_btn" :scroll_top_Callback="scroll_top_Callback" />
        <LoginDialog ref="ref_login_dialog" />
        <UserDialog ref="ref_user_dialog" :dialog_changeUser_callback="user_dialog_changeUser" />
    </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onBeforeUnmount, getCurrentInstance, nextTick, computed } from 'vue';
import NavHeader from '@/components/Navgation/NavHeader.vue';
import NavFooter from '@/components/Navgation/NavFooter.vue';
import DynamicBg from '@/components/DynamicStyle/DynamicBgComp.vue';
import ScrollTopBtn from '@/components/ScrollTopBtn/ScrollTopButton.vue';
import LoginDialog from '@/components/Account/LoginDialog.vue';
import UserDialog from '@/components/Account/UserDialog.vue';
import { useRouterStore } from '@/stores/router';
import { useUserStore } from '@/stores/user';
import { useStateStore } from '@/stores/state';
import { useMessageStore } from '@/stores/message';

const router_store = useRouterStore();
const user_store = useUserStore();
const state_store = useStateStore();
const message_store = useMessageStore();
const { proxy } = getCurrentInstance();

const ref_custom_sup_box = ref(null);
const ref_login_dialog = ref(null);
const ref_user_dialog = ref(null);

// 顶部背景色
const nav_header_bg_color = computed(() => {
    let background = proxy.$globalObj.color.__color_main_nav_light_bg;
    if (state_store.nav_bg_style == 1) {
        background = proxy.$globalObj.color.__color_main_nav_dark_bg;
    } else {
        background = proxy.$globalObj.color.__color_main_nav_light_bg;
    }
    return `background:${background}`;
});

onBeforeMount(() => {
    let path = proxy.$route.path;

    if (path.includes('index')) {
        router_store.navigateToHome();
    }
});

onMounted(() => {
    nextTick(() => {
        window.addEventListener('scroll', win_event_listen_scroll, true);
    });
});
onBeforeUnmount(() => {
    window.removeEventListener('scroll', win_event_listen_scroll);
});

// MARK 跳转  顶部导航
const nav_header_router = (item) => {
    if (!item.route || !item.route.length) return;
    router_store.navigateTo(item.route);
    nextTick(() => {
        if (ref_custom_sup_box.value) {
            ref_custom_sup_box.value.scrollTop = 0;
        }
    });
};
// MARK 跳转  底部导航
const nav_footer_router = (item) => {
    if (!item.route || !item.route.length) return;

    router_store.navigateTo(item.route);
    nextTick(() => {
        if (ref_custom_sup_box.value) {
            ref_custom_sup_box.value.scrollTop = 0;
        }
    });
};
// MARK 跳转  转换中心
const nav_tran_platform = () => {
    router_store.windowOpenPlatform(0);
};
// MARK 跳转  用户
const nav_user = (isLogin) => {
    if (isLogin) {
        ref_user_dialog.value.show_dialog();
    } else {
        ref_login_dialog.value.show_dialog();
    }
};
// MARK Callback 切换账号
const user_dialog_changeUser = () => {
    ref_login_dialog.value.show_dialog();
};

// MARK listen 滚动
const win_event_listen_scroll = () => {
    if (ref_custom_sup_box.value) {
        let scrollTop = ref_custom_sup_box.value.scrollTop;
        let devCenterSwitchBg = proxy.$globalObj.color.__color_main_nav_dark_bg;
        if (scrollTop > proxy.$globalObj.config.__nav_height) {
            devCenterSwitchBg = proxy.$globalObj.color.__color_main_nav_dark_bg;
        } else {
            devCenterSwitchBg = proxy.$globalObj.color.__color_main_transparent_bg;
        }
        // 通知开发者文档页面滚动
        message_store.sendMessage(message_store.M_E_NAV_SCROLL, { devCenterSwitchBg: devCenterSwitchBg });
    } else {
    }
};
// MARK ScrollTop 点击
const scroll_top_Callback = (animation = true) => {
    const element = ref_custom_sup_box.value;
    if (element) {
        const startPosition = element.scrollTop;
        const change = -startPosition;
        if (animation) {
            const duration = 500; // 滚动动画持续时间，单位为毫秒
            let startTime = null;

            function smoothScroll(currentTime) {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const progress = Math.min(timeElapsed / duration, 1); // 计算动画的进度
                element.scrollTop = startPosition + change * easeInOutCubic(progress);
                // 如果时间未到，继续执行滚动动画
                if (timeElapsed < duration) requestAnimationFrame(smoothScroll);
            }
            // 缓动函数
            function easeInOutCubic(t) {
                return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
            }
            requestAnimationFrame(smoothScroll);
        } else {
            element.scrollTop = startPosition + change;
        }
    }
};
</script>

<style lang="less" scoped>
.nav-control-body {
    width: 100%;
    min-width: var(--min-width-limit);
    height: 100%;
    position: relative;

    .dynamic-bg-color {
        background-color: var(--color-main-light-bg-white);

        .custom-sup-box {
            position: relative;
            margin-top: var(--nav-height);
            width: 100%;
            min-width: var(--min-width-limit);
            height: calc(100% - var(--nav-height));
            overflow-y: auto;
            display: flex;
            flex-direction: column;
        }

        .route-content-body {
            position: relative;
            display: flex;
            width: 100%;
        }
    }
}
</style>
